import { ReducerBuilder } from './reducerBuilder';
import { Gift, GiftCategory, GiftsState } from 'acscp/store/giftsState';
import { GiftsRequest, LoyaltyOrderRequest } from 'acscp/api/requests';
import { GiftsList } from 'acscp/api/models/giftsList';
import { AmendBasket, RemoveUnavailableGifts } from 'acscp/actions';

export const giftsReducer =
    new ReducerBuilder<GiftsState>({
        giftsList: {},
        giftCategories: {},
        balance: null,
        giftBasketQuantities: {},
        basketSubmitted: false,
    })
        .successfulRequestCase(GiftsRequest, (state, response: GiftsList) => {
            const newGiftList: { [key: string]: Gift; } = {};
            response.availableGifts.forEach(g => {
                if (!!g.categoryId) {
                    newGiftList[g.id] = g;
                }
            });
            const newCategories: { [key: string]: GiftCategory; } = {};
            response.giftCategories.forEach(c => {
                newCategories[c.id] = c;
            });
            return {
                ...state,
                giftsList: newGiftList,
                giftCategories: newCategories,
                balance: response.balance
            };
        })
        .successfulRequestCase<undefined, LoyaltyOrderRequest>(LoyaltyOrderRequest, (state, response) => {
            return {
                ...state,
                giftBasketQuantities: {},
                basketSubmitted: true,
            };
        })
        .actionCase(AmendBasket, (state, action) => {
            const currentQuantity = action.giftId in state.giftBasketQuantities
                ? state.giftBasketQuantities[action.giftId]
                : 0;
            const newQuantity = currentQuantity + action.quantity;

            const giftBasketQuantities = {...state.giftBasketQuantities};
            if (newQuantity <= 0) {
                delete giftBasketQuantities[action.giftId];
            } else {
                giftBasketQuantities[action.giftId] = newQuantity;
            }
            return {
                ...state,
                giftBasketQuantities,
                basketSubmitted: false
            };
        })
        .actionCase(RemoveUnavailableGifts, (state, action) => {
            const giftBasketQuantities = {...state.giftBasketQuantities};

            Object.keys(state.giftBasketQuantities).filter(giftId =>
                !state.giftsList[giftId]
            ).forEach(giftId =>
                delete giftBasketQuantities[giftId]
            );
            return {
                ...state,
                giftBasketQuantities
            };
        })
        .build();
